import { Component, OnDestroy, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-helper-screen',
  templateUrl: './helper-screen.component.html',
  styleUrls: ['./helper-screen.component.css']
})
export class HelperScreenComponent implements OnInit,OnDestroy {
  helperData: any;
  timer;
  resdata: any;
  data:any;
  source: String;
  brandUrlForHelper: any;


  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  ngOnDestroy(): void {
    clearTimeout(this.timer);
    window.location.reload();
  }

  ngOnInit(): void {
      // this.helperData=JSON.parse(localStorage.getItem('helperData'));
      // (<any> window).myFunc();
      // this.timer= setTimeout(() => {
      //  window.location.href = localStorage.getItem('brandUrlForHelper');
      // },10000);
      this.activatedRoute.queryParams.subscribe(params => {
        this.resdata = params['data'] ? params['data'] : null;
        this.source = params["source"] != null ? JSON.parse(params["source"]) : null;
        this.data = JSON.parse(this.resdata);
        
        if (this.source == "BT") {
          this.helperData =this.data.helperData;
          (<any>window).myFunc();
          this.timer = setTimeout(() => {
            window.location.href = this.data.brandUrlForHelper;
          }, 10000);
        } else {
          this.helperData = JSON.parse(sessionStorage.getItem('helperData'));
          (<any>window).myFunc();
          this.timer = setTimeout(() => {
            window.location.href = sessionStorage.getItem('brandUrlForHelper');
          }, 10000);
        }
      });
   
  }
  redirect(){
    window.location.href = localStorage.getItem('brandUrlForHelper');
  }
  

}


